import { render } from "./ModalEditInc.vue?vue&type=template&id=3b32a2fa"
import script from "./ModalEditInc.vue?vue&type=script&lang=js"
export * from "./ModalEditInc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__